import { render, staticRenderFns } from "./ProjectSettingAsset.vue?vue&type=template&id=10411972"
import script from "./ProjectSettingAsset.vue?vue&type=script&lang=js"
export * from "./ProjectSettingAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports